import { FormFields } from "@/types";
import { $t } from "@/lib/helpers/i18nHelper";
import { isAfter } from "@/lib/helpers/time";

export const fields: FormFields = [
  {
    name: "user",
    title: $t("User"),
    placeholder: $t("Put here ID, name, email or IP"),
    clearable: false,
    type: "autocomplete",
  },
  {
    name: "subscriptionLevel",
    title: $t("Subscription level"),
    clearable: false,
    type: "select",
    list: [],
  },
  {
    name: "expirationDate",
    title: $t("End of subscription"),
    clearable: false,
    value: {
      dateStart: "",
      dateEnd: "",
    },
    allowedDates: (date: string) => !isAfter(new Date(), new Date(date)),
    placeholder: "",
    type: "date",
  },
];
